import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-defa9dba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dialog-content" }
const _hoisted_2 = ["src"]

import { computed } from 'vue';
  
  
export default /*#__PURE__*/_defineComponent({
  __name: 'TermsAndConditions',
  props: {
    modelValue: {
      type: Boolean,
      required: true
    },
    image: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    content: {
      type: String,
      required: true
    }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {

  const props = __props;
  
  const emit = __emit;
  
  const showDialog = computed(() => props.modelValue);
  
  function close() {
    emit('update:modelValue', false);
  }
  
return (_ctx: any,_cache: any) => {
  return (showDialog.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "dialog-overlay",
        onClick: _withModifiers(close, ["self"])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("img", {
            src: __props.image,
            alt: "Dialog Image"
          }, null, 8, _hoisted_2),
          _createElementVNode("h2", null, _toDisplayString(__props.title), 1),
          _renderSlot(_ctx.$slots, "subtitle"),
          _createElementVNode("p", null, _toDisplayString(__props.content), 1),
          _renderSlot(_ctx.$slots, "additionalContent")
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})